// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__28sN3","inner":"Form_inner__1f2yC","range":"Form_range__7MRis","name":"Form_name__3wC8W","actions":"Form_actions__1N9cA"};